module.exports = __webpack_public_path__ + "static/media/sort-dropdown.a5edcfa7.svg";